import React, { useState } from "react";
import { MdGridView, MdOutlineFormatListBulleted } from "react-icons/md";

const SegmentedTab = ({ onChange }) => {
  const [selected, setSelected] = useState("grid");

  const handleSelect = (value) => {
    setSelected(value);
    if (onChange) onChange(value);
  };

  return (
    <div className="flex border border-outline rounded-xl overflow-hidden w-fit">
      <button
        className={`flex items-center justify-center px-4 py-3 transition ${
          selected === "grid"
            ? "bg-[#E4EFF3] border-r border-outline"
            : "bg-white"
        }`}
        onClick={() => handleSelect("grid")}
        aria-label="Grid View"
        type="button"
      >
        <MdGridView className="text-2xl text-onSurfaceVariant" />
      </button>
      <button
        className={`flex items-center justify-center px-4 py-3 transition ${
          selected === "list" ? "bg-[#E4EFF3]" : "bg-white"
        }`}
        onClick={() => handleSelect("list")}
        aria-label="List View"
        type="button"
      >
        <MdOutlineFormatListBulleted className="text-2xl text-onSurfaceVariant" />
      </button>
    </div>
  );
};

export default SegmentedTab;